import React, { useEffect, useState, useRef } from "react";
import PPScatterPlot from '../PP_ScatterPlot/PP_ScatterPlot';
import styles from "./CP.module.css";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { csvParse } from "d3-dsv";

const CP = ({
  resultData,
  PPType,
  CGdbType,
  loading,
  setLoading
}) => {

  const[genesetSize, setGenesetSize] = useState(0);
  const[pvalue, setPvalue] = useState(0);
  const svgRef = useRef(null);
  const onDownloadBtn = async () => {
    if (!svgRef.current) return;
    alert("download might take few minutes!")
    const canvas = await html2canvas(svgRef.current, { scale: 4 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("CANCER COMPASS_bubble plot_pval.pdf");
  };

  useEffect(()=>{
    if(resultData !== null){
      setGenesetSize(resultData.size)
      setPvalue(resultData.pvalue)
      resultData.pvalue > 8 && setPvalue(8) 
    }
  },[resultData])


  const [data, setData] = useState([]);
  useEffect(() => {
    fetch(`https://raw.githubusercontent.com/jheonii/compass_db/main/pp_scatter_${CGdbType}.csv`)
      .then(response => response.text())
      .then(data => {
        const parsedData = csvParse(data);
        console.log(parsedData)
        // 이름 매핑 객체
        const legendNames = {
          'y005': 'cutoff 0.05',
          'y001': 'cutoff 0.01',
          'y0001': 'cutoff 0.001',
        };

        // y005, y001, y0001에 대한 traces 생성
        const traces = ['y005', 'y001', 'y0001'].map(yValue => {
          return {
            x: parsedData.map(row => +parseInt(row['x'])),
            y: parsedData.map(row => -Math.log10(+row[yValue])),

            mode: 'markers',
            type: 'scatter',
            name: legendNames[yValue] || yValue,  // 매핑 객체를 사용하여 이름 가져오기
            marker: { size: 5 }
          };
        });

        console.log(traces)
        const trace2Lines = {
          // y-axis line
          x: [genesetSize, genesetSize],
          y: [0, 8],
          mode: "lines",
          line: { color: "black", width: 2, dash: 'dot' },  // 'dot' 추가
          type: "scatter",
          showlegend: false,
        }

        const trace2dot = {
          // y-axis line
          x: [genesetSize],
          y: [pvalue], // 이 값은 원하는 y 좌표에 따라 변경할 수 있습니다.
          mode: 'markers',
          type: 'scatter',
          marker: {
            size: 7,
            color: 'black'  // 이 부분은 원하는 색상으로 변경하세요. 현재는 빨간색으로 설정되어 있습니다.
          },
          name: `geneset size (n=${genesetSize})`,
        }

        setData([...traces, trace2Lines, trace2dot]);
      });
  }, [genesetSize, pvalue, resultData]);


  return (
    <div style={{paddingBottom: '50px'}}>
      <h1 className={styles.mainTitle} style={{ margin: 0 }}>
        ◼️ Pathway Prioritization Results
      </h1>
      {resultData !== null && (
        <>
          <p style={{ margin: "0 0 40px 0" }}>
            🔍
            <span style={{ fontWeight: "bolder" }}>
              {" "}
              {localStorage.getItem("intersec_CP")}{" "}
            </span>
            of
            <span style={{ fontWeight: "bolder" }}>
              {" "}
              {localStorage.getItem("total_CP")}{" "}
            </span>
            accession numbers →
            <span style={{ fontWeight: "bolder" }}>
              {" "}
              {localStorage.getItem("percent_CP")}%{" "}
            </span>
            from your input list were mapped!
          </p>
        </>
      )}
      <h2 className={styles.pathwayName}>
        {resultData === null
          ? <div style={{color :'#aaacae', fontWeight:'bold'}}>ex.Level 1~4 {PPType} pathway</div>
          : <div>{resultData.cancerLevel}</div> }
      </h2>
      <div className={styles.container}>
        <div className={styles.leftCnt}>
          <div className={styles.infoCnt}>
            <div className={styles.infoTitle}>ORA P-value:</div>
            <div className={styles.infoValue}>
              {resultData === null
                ? <div style={{color :'#aaacae', fontWeight:'bold'}}>ex. 1.32E-03</div>
                : resultData.pvalue_string}
            </div>
          </div>
          <div className={styles.infoCnt}>
            <div className={styles.infoTitle}>Gene set size:</div>
            <div className={styles.infoValue}>
              {resultData === null
                ? <div style={{color :'#aaacae', fontWeight:'bold'}}>ex. 200</div>
                : resultData.size}
            </div>
          </div>
          <div className={styles.infoCnt}>
            <div className={styles.infoTitle}>Number of overlapping genes:</div>
            <div className={styles.infoValue}>
              {resultData === null
                ? <div style={{color :'#aaacae', fontWeight:'bold'}}>ex. 32</div>
                : resultData.overlap}
            </div>
          </div>
          <div className={styles.infoCnt}>
            <div className={styles.infoTitle}>
              Overlapping genes with consensus {CGdbType} genes <br/>(EntrezID):{" "}
            </div>
            <div className={styles.infoValue}>
              {resultData === null
                ? <div style={{color :'#aaacae', fontWeight:'bold'}}>ex. 7424;2690;90627;11011;4613;59269;223117;6416;83478;8218;26524;117154;80816;9651;50485;5045;219578;9671;1869;5326;207;208;2257;5584;1107;1748;1621;83931;476;63976;83439;8945;1910;10103;1788</div>
                : resultData.entrezId}
            </div>
          </div>
          <div className={styles.infoCnt}>
            <div className={styles.infoTitle}>
            Overlapping genes with consensus {CGdbType} genes <br/>(HGNC Symbol):{" "}
            </div>
            <div className={styles.infoValue}>
              {resultData === null
                ? <div style={{color :'#aaacae', fontWeight:'bold'}}>ex. VEGFC;GHR;STARD13;TLK2;MYCN;HIVEP3;SEMA3D;MAP2K4;ARHGAP24;CLTCL1;LATS2;DACH2;ASXL3;PLCH2;SMARCAL1;FURIN;ZNF804B;WSCD2;E2F1;PLAGL2;AKT1;AKT2;FGF12;PRKCI;CHD3;DLX4;DBH;STK40;ATP1A1;PRDM16;TCF7L1;BTRC;EDNRB;TSPAN1;DNMT3A</div>
                : resultData.symbol}
            </div>
          </div>
        </div>
        <div className={styles.rightCnt}>
          <PPScatterPlot 
          data={data}
          svgRef={svgRef} 
          onDownloadBtn={onDownloadBtn}/>
        </div>
      </div>
    </div>
  );
};

export default CP;
